import endpoints from "@config/endpoints";
import { AncServiceForm } from "@constants/ancConstants";
import { getData, postDataJSON } from "@services/CommonApiService";
import { errorLogger } from "@utils/applicationLogUtils";
import { toast } from "react-toastify";

export const getLatestServiceAvailedDate = async (pregnancyId: any) => {
    try {
        if(pregnancyId) {
            const res = await getData<any>(`${endpoints.getLatestServiceAvailedDate}/${pregnancyId}`);
            if (res && (res.data || res.data.length > 0)) {
                return res;
            } else {
                return null;
            }
        }
        return null;
    } catch (error: any) {
        toast.error(AncServiceForm.GET_API_ERROR_MESSAGE(AncServiceForm.LATEST_SERVICE_AVAILED_DATE), {
            position: "top-center"
        });
        errorLogger(error?.response?.data || error?.response || error);
    };
};

export const getServiceDetailsUnderCurrentDate = async (
    serviceCategory: string,
    beneficiaryId: string,
    pregnancyId: string = '',
    visitNumber: number | string,
    serviceSubcategoryId: string = ''
) => {
    try {
        const payload = {
            serviceCategory: serviceCategory || null,
            benefId: beneficiaryId || null,
            pregnancyId: pregnancyId || null,
            visitNo: visitNumber || null,
            serviceSubCatId: serviceSubcategoryId || null
        };
        const res = await postDataJSON<any>(endpoints.getServiceDetailsUnderCurrentDate, payload);
        return res;
    } catch (error: any) {
        toast.error('Failed to fetch service current records', {
            position: "top-center"
        });
        errorLogger(error?.response?.data || error?.response || error);
        throw error;
    }
};